import { NavMenu } from '../Navigation/NavMenu/NavMenu';

import './Layout.scss';

export default function Layout({ children }) {
  return (
    <div id="layout">
      <NavMenu />
      <div id="page-content-wrapper">{children}</div>
    </div>
  );
}
